import React from 'react'
import styles from '../UnderstandingOur2/UnderstandingOur.module.css'

const UnderstandingOur2 = () => {
  return (
   <div className={styles.ContainerBox}>
            <div className={styles.Container}>
                <div className={styles.headerBar}>
                    <p>Understanding Our</p>
                    <h1>Privacy and Policy</h1>
                </div>
                <div className={styles.Descriptions}>
                    <h3>Who We Are (DesignersX)</h3>
                    <p>DesignersX is the innovative developer and dedicated provider of the Rexpt AI Receptionist Service. The core mission is to empower Small & Medium Businesses with cutting-edge artificial intelligence solutions that streamline their operations and enhance customer interactions. Official contact details for DesignersX, including the designated privacy contact, are readily available in the "Contact Us" section of this Policy for any inquiries or concerns related to data privacy.</p>
                    <hr className={styles.hrLine}/>
                </div>

            </div>

        </div>
  )
}

export default UnderstandingOur2
